<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    class="agpr-dropdown"
    [id]="id"
    [ngClass]="{ 'agpr-dropdown--borderless': style === dropdownTypesEnum.borderless,
        'agpr-dropdown--socialPlus': agprStyle === agprComponentStyle.socialPlus
    }"
>
    <!-- Container -->
    <div
        #container
        class="agpr-dropdown-container"
        [ngClass]="dropdownContainerStyleClass"
        [class.agpr-dropdown-container--borderless]="style === dropdownTypesEnum.borderless"
        [pTooltip]="(isInputTruncated ? value?.label : inputTooltip) | localize"
        [tooltipPosition]="inputTooltipPosition"
        [tooltipStyleClass]="inputTooltipStyleClass"
    >
        <ng-container *ngIf="itemTemplate">
            <div
                #focusInput
                role="combobox"
                class="agpr-dropdown-input"
                [attr.aria-label]="ariaLabel | localize"
                [attr.aria-labelledby]="ariaLabelledBy"
                [attr.aria-describedby]="ariaDescribedBy"
                [attr.aria-expanded]="panelVisible"
                [attr.aria-haspopup]="'listbox'"
                [attr.aria-controls]="id + '_listbox'"
                [attr.aria-required]="ariaRequired"
                tabindex="0"
                (focus)="onInputFocus($event)"
                (keydown)="onKeydown($event)"
                (keyup)="onKeyup($event)"
                (click)="onMouseclick($event)"
            >
                <ng-container
                    *ngTemplateOutlet="itemTemplate; context: {$implicit: value}">
                </ng-container>
                <!-- Trigger Button -->
                <span
                    class="agpr-dropdown-triggerIcon fa-solid fa-angle-down agpr-expandToggle"
                    [ngClass]="{'agpr-dropdown-triggerIcon--disabled': disabled}"
                    aria-hidden="true"
                    [id]="id"
                ></span>
            </div>
        </ng-container>
        <ng-container *ngIf="!itemTemplate">
            <ng-container *ngIf="style === dropdownTypesEnum.borderless; else input">
                <div
                    #focusInput
                    role="combobox"
                    class="agpr-dropdown-container--borderless-input"
                    [ngClass]="{'agpr-dropdown-input-placeholder': !value?.label}"
                    [attr.aria-label]="ariaLabel | localize"
                    [attr.aria-labelledby]="ariaLabelledBy"
                    [attr.aria-describedby]="ariaDescribedBy"
                    [attr.aria-expanded]="panelVisible"
                    [attr.aria-haspopup]="'listbox'"
                    [attr.aria-controls]="id + '_listbox'"
                    [attr.aria-required]="ariaRequired"
                    tabindex="0"
                    (keydown)="onKeydown($event)"
                    (keyup)="onKeyup($event)"
                    (click)="onMouseclick($event)"
                >
                <div class="agpr-dropdown-input-container">
                    <div
                        #dropdownText
                        (mouseenter)="checkTruncatedText(dropdownText)"
                        [pTooltip]="showTooltip && isTruncated ? value.label: null"
                        tooltipPosition="top"
                        [class]="showTooltip? 'agpr-dropdown-input--borderless agpr-dropdown-input--borderless-truncated': 'agpr-dropdown-input--borderless'"
                    >
                        {{ (value?.label ? value.label : placeholder) | localize }}
                    </div>
                    <span
                        class="agpr-dropdown-triggerIcon fa-solid fa-angle-down agpr-expandToggle"
                        [ngClass]="{'agpr-dropdown-triggerIcon--borderless': style === dropdownTypesEnum.borderless,
                            'agpr-dropdown-triggerIcon--disabled': disabled}"
                        aria-hidden="true"
                        [id]="id"
                    ></span>
                </div>
            </div>
            </ng-container>
            <ng-template #input>
                <!-- Label -->
                <label
                    *ngIf="label"
                    class="agpr-dropdown-label"
                    [ngClass]="[labelClass, labelStyleClass].filter(c => c)"
                    [for]="id + '.input'"
                >
                    {{ label | localize }}
                    <span *ngIf="required" class="agpr-requiredAsterix"> * </span>
                    <!-- Info Icon -->
                    <span
                        *ngIf="infoCircleTooltip"
                        role="img"
                        class="fa-regular fa-circle-info agpr-dropdown-tooltip"
                        [agprTooltip]="infoCircleTooltip | localize"
                        [initiallyFocusable]="!isInTable"
                    ></span>
                </label>
                <div
                    class="agpr-dropdown-input-container"
                    [ngClass]="{'agpr-dropdown-input-container--disabled': !showInput && disabled}"
                    (click)="onMouseclick($event)"
                >
                    @if(showInput) {
                        <input
                            #focusInput
                            role="combobox"
                            readonly
                            type="text"
                            [id]="id + '.input'"
                            class="agpr-dropdown-input"
                            [ngClass]="{'agpr-dropdown-input--withIcon': value?.icon }"
                            [style.min-width.ch]="(scaleDropdownLabel && value?.label)
                                ? (value.label | localize).length + 6
                                : null"
                            [disabled]="disabled"
                            [placeholder]="placeholder | localize"
                            [attr.aria-label]="ariaLabel | localize"
                            [attr.aria-labelledby]="ariaLabelledBy"
                            [attr.aria-describedby]="ariaDescribedBy"
                            [attr.aria-expanded]="panelVisible"
                            [attr.aria-haspopup]="'listbox'"
                            [attr.aria-controls]="id + '_listbox'"
                            [attr.aria-required]="ariaRequired"
                            [ngModel]="value?.label | localize"
                            (focus)="onInputFocus($event)"
                            (blur)="onInputBlur($event)"
                            (keydown)="onKeydown($event)"
                            (keyup)="onKeyup($event)"
                        />
                    }
                    @if(!showInput && replaceInputIcon) {
                        <span
                            class="agpr-dropdown-noInput-icon {{ replaceInputIcon }}"
                            [ngClass]="{'agpr-dropdown-noInput-icon--disabled': disabled}"
                            aria-hidden="true"
                        ></span>
                    }
                    <span
                        *ngIf="value?.icon"
                        class="agpr-dropdown-input-icon {{ value.icon }}"
                        aria-hidden="true"
                    ></span>
                    <span
                        *ngIf="infoCircleTooltip && !label"
                        role="img"
                        class="fa-regular fa-circle-info agpr-dropdown-tooltip"
                        [agprTooltip]="infoCircleTooltip | localize"
                        [initiallyFocusable]="!isInTable"
                    ></span>
                    <!-- Trigger Button -->
                    <span
                        class="agpr-dropdown-triggerIcon fa-solid fa-angle-down agpr-expandToggle"
                        [ngClass]="{'agpr-dropdown-triggerIcon--disabled': disabled}"
                        aria-hidden="true"
                        [id]="id + '_dropdown_triggerIcon'"
                    ></span>
                </div>
            </ng-template>
        </ng-container>
        <!-- Dropdown Panel -->
        <div
            #panel
            [id]="id + '.panel'"
            [class]="'agpr-clickOutsideExcluded agpr-dropdown-panel ' + panelStyleClass"
            [@panelState]="panelVisible ? 'visible' : 'hidden'"
            [style.display]="panelVisible ? 'block' : 'none'"
        >
            <div #itemswrapper>
                <ul
                    role="listbox"
                    [id]="id + '_listbox'"
                    class="agpr-dropdown-panel-items"
                >
                    <li
                        *ngIf="showHiddenOption && hiddenCount"
                        class="agpr-dropdown-item agpr-dropdown-panel-item agpr-dropdown-showHidden"
                        role="option"
                        (click)="toggleHiddenItems($event)"
                    >
                        {{ (showHidden ? 'Common.forms.autocomplete.hideHidden' : 'Common.forms.autocomplete.showHidden')
                        | localize: {count: hiddenCount > 10 ? '10+' : hiddenCount} }}
                    </li>
                    <li
                        *ngIf="showHiddenOption && hiddenCount"
                        class="agpr-dropdown-panel-item-divider"
                    ></li>
                    <li
                        #directives
                        *ngFor="let option of optionsToDisplay; let i = index"
                        role="option"
                        [id]="id + '_dropdownOption_' + i"
                        class="agpr-dropdown-item agpr-dropdown-panel-item {{ optionStyleClass }}"
                        [ngClass]="{
                            'agpr-dropdown-panel-selectedItem': option.value === value?.value,
                            'agpr-dropdown-panel-focusedItem': i === focusedItemIndex,
                            'agpr-dropdown-panel-disabledItem': option.disabled
                        }"
                        [agprTooltip] = "(tooltipPath ? tooltipPath + option.enumValue : '') | localize"
                        [tooltipPosition]="itemTooltipPosition"
                        [attr.aria-selected]="option.value === value?.value"
                        [attr.aria-disabled]="option.disabled"
                        (click)="onItemClick($event, i)"
                    >
                        <div class="agpr-dropdown-panel-item-activeBar"></div>
                        <div *ngIf="!itemTemplate" class="agpr-dropdown-panel-item-label">
                            <span
                                *ngIf="option.icon"
                                class="agpr-dropdown-panel-icon {{ option.icon }}"
                            ></span>
                            <span class="agpr-dropdown-panel-item-mainLabel">
                                {{ option.label | localize }}
                            </span>
                            <span class="agpr-dropdown-panel-subLabel">
                                {{ option.subLabel | localize }}
                            </span>
                            <span
                                *ngIf="showHiddenOption && showHidden && option.value.hidden"
                                class="agpr-dropdown-panel-item-hidden fa-regular fa-duotone fa-eye-slash"
                                role="img"
                                [agprTooltip]="'Common.forms.autocomplete.itemHidden'"
                            ></span>
                        </div>

                        <span
                            *ngIf="tooltipPath"
                            class="u-srOnly"
                        >
                            {{ (tooltipPath + option.enumValue) | localize }}
                        </span>
                        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: option, selected: option.value === value?.value }"></ng-container>
                    </li>
                    @if(callToAction) {
                        <li>
                            <div class="agpr-dropdown-panel-callToAction">
                                <a class="agpr-dropdown-panel-callToAction-link" (click)="callToAction.action()">{{ callToAction.label | localize }}</a>
                            </div>
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
</div>

